// View model for the player card's exceptions tile: the exceptions in play. exception is the
// manager's grant ({ granted, reason }) in the 400–499.99 band.
import { isCCExceptionTag } from './wagering';

// ccCombinedItem: deposits in more than one currency are combined into a "VIP comp CC", unless the
// "NO more VIP Comp CC exceptions" tag keeps them apart.
const ccCombinedItem = (deposits = {}) => {
  const currencies = (deposits.by_currency || []).map((d) => d.currency);
  if (currencies.length < 2 || deposits.cc_exception_applied) return null;
  return {
    key: 'cc_combined',
    label: 'CC exception',
    detail: `${currencies.length} currencies combined (${currencies.join(' + ')}) · VIP comp CC`,
    tone: 'positive',
  };
};

// exceptionItems: the CC exception (combined currencies or the tag that stops it) and the
// exception band, each with what it means here.
export const exceptionItems = (check, exception = {}) => {
  const items = [];
  const cc = ccCombinedItem(check.deposits);
  if (cc) items.push(cc);
  if ((check.player?.tags || []).some(isCCExceptionTag)) {
    items.push({
      key: 'cc',
      label: 'No more CC exceptions',
      detail: check.deposits?.cc_exception_applied ? 'currencies not combined — top currency only' : 'one currency, no effect',
      tone: check.deposits?.cc_exception_applied ? 'warning' : 'muted',
    });
  }
  if (check.decision === 'needs_exception') {
    const granted = Boolean(exception.granted && exception.reason?.trim());
    items.push({
      key: 'band',
      label: 'Exception band 400–499.99',
      detail: granted ? 'one-off exception granted' : 'manager decision needed',
      tone: granted ? 'positive' : 'warning',
    });
  }
  return items;
};
